<div class="modal-header" *ngIf="header" [ngClass]="classes?.header">
  <ng-content select="[modal-header]"></ng-content>
  <button class="close btn" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" *ngIf="body" [ngClass]="classes?.body">
  <ng-content select="[modal-body]"></ng-content>
</div>
<div class="modal-footer" *ngIf="footer" [ngClass]="classes?.footer">
  <ng-content select="[modal-footer]"></ng-content>
</div>
